import FileSaver from 'file-saver';
import { toBlob } from 'html-to-image';
import { path } from '../utils/fp';
import { getFilter } from '../selectors';
import { getRawDataRequestArgs } from '../selectors/sdmx';
import { HANDLE_STRUCTURE, CHANGE_DATAFLOW, RESET_DATAFLOW } from './sdmx';
import { SET_PENDING } from './app';
import { getFilename } from '../lib/sdmx';
import { PANEL_USED_FILTERS } from '../utils/constants';
import { RESET_SEARCH } from './search';

//---------------------------------------------------------------------------------------------model
const model = () => ({
  actionId: undefined,
  isFull: false,
  title: undefined,
  filter: PANEL_USED_FILTERS,
  excel: { error: undefined, id: undefined },
  png: { error: undefined, id: undefined },
  hasCsvDlStart: false, // to be used for browser dl launch message
  shared: false,
  // bumped to ask the filters drawer to drop its pending selection
  filtersSelectionKey: 0,
});

//-------------------------------------------------------------------------------------------actions
const CHANGE_ACTION_ID = '@@vis/CHANGE_ACTION_ID';
const CHANGE_FULLSCREEN = '@@vis/CHANGE_FULLSCREEN';
export const CHANGE_LAYOUT = '@@vis/CHANGE_LAYOUT';
export const SHARE_SUCCESS = '@@vis/SHARE_SUCCESS';
export const DOWNLOAD_FILE_SUCCESS = '@@vis/DOWNLOAD_FILE_SUCCESS ';
const DOWNLOAD_FILE_ERROR = '@@vis/DOWNLOAD_FILE_ERROR ';
export const CHANGE_VIEWER = '@@vis/CHANGE_VIEWER';
const CHANGE_FILTER = '@@vis/CHANGE_FILTER';
const CLEAR_FILTERS_SELECTION = '@@vis/CLEAR_FILTERS_SELECTION';
const CSV_DL_START = '@@vis/CSV_DL_START';

//------------------------------------------------------------------------------------------creators
export const changeFilter = filterId => (dispatch, getState) => {
  const prevFilterId = getFilter(getState());
  const filter = filterId === prevFilterId ? null : filterId;
  dispatch({ type: CHANGE_FILTER, payload: { filter } });
};
export const clearFiltersSelection = () => ({ type: CLEAR_FILTERS_SELECTION });
export const changeFullscreen = (isFull, isOpening) => ({
  type: CHANGE_FULLSCREEN,
  payload: { isFull, isOpening },
});
export const changeActionId = actionId => ({
  type: CHANGE_ACTION_ID,
  payload: { actionId },
});
export const shareSuccess = () => ({
  type: SHARE_SUCCESS,
  payload: {},
});
export const csvDlStartTick = () => ({ type: CSV_DL_START });

//--------------------------------------------------------------------------------------thunks (api)
export const downloadFile =
  ({ blob, ext, id }) =>
  (dispatch, getState) => {
    // for a better accuracy
    // pending has to be set true at the begining of your parsing
    const args = getRawDataRequestArgs(getState());
    const fileName = getFilename(args);
    try {
      FileSaver.saveAs(blob, `${fileName}${ext}`);
      dispatch({ type: SET_PENDING, payload: { id, is: false } });
      dispatch({ type: DOWNLOAD_FILE_SUCCESS, payload: { id, fileName } });
    } catch (error) {
      dispatch({ type: DOWNLOAD_FILE_ERROR, payload: { error, id } });
    }
  };

export const downloadPng =
  ({ id, el, options }) =>
  dispatch => {
    dispatch({ type: SET_PENDING, payload: { id, is: true } });

    return toBlob(el, options).then(function (blob) {
      dispatch(downloadFile({ id, blob, ext: '.png' }));
    });
  };

//-------------------------------------------------------------------------------------------reducer
export default (state = model(), action = {}) => {
  switch (action.type) {
    case HANDLE_STRUCTURE:
      // TO CHECK with the team: layout is not stored in vis state
      // but in router state
      return { ...state, title: path(['structure', 'name'], action) };
    case CHANGE_FULLSCREEN:
      return {
        ...state,
        isFull: path(['payload', 'isFull'], action),
        isOpeningFullscreen: path(['payload', 'isOpening'], action),
      };
    case CHANGE_ACTION_ID:
      return {
        ...state,
        actionId: state.actionId === action.payload.actionId ? undefined : action.payload.actionId,
      };
    case CHANGE_VIEWER:
      return { ...state, actionId: undefined };
    case CHANGE_LAYOUT:
      return { ...state, actionId: undefined };
    case CHANGE_FILTER:
      return { ...state, filter: action.payload.filter };
    case CLEAR_FILTERS_SELECTION:
      return { ...state, filtersSelectionKey: state.filtersSelectionKey + 1 };
    case DOWNLOAD_FILE_ERROR:
      return {
        ...state,
        [action.payload.id]: {
          error: action.payload.error,
          id: action.payload.id,
        },
      };
    case DOWNLOAD_FILE_SUCCESS:
      return {
        ...state,
        [action.payload.id]: { error: undefined, id: action.payload.id },
      };
    case CSV_DL_START:
      return { ...state, hasCsvDlStart: !state.hasCsvDlStart };
    case SHARE_SUCCESS:
      return { ...state, shared: !state.shared };
    case RESET_SEARCH:
    case RESET_DATAFLOW:
    case CHANGE_DATAFLOW:
      return model();
    default:
      return state;
  }
};
